import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=10af742e&scoped=true&"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js&"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalMenu.vue?vue&type=style&index=0&id=10af742e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10af742e",
  null
  
)

export default component.exports